import { Lock, MapPin } from 'lucide-react';
import { FC, memo } from 'react';

import { EventInfoProps } from './types';
import { ZERO_TIME } from 'utils/constants';
import styles from './EventInfoHeader.module.css';

const EventInfoHeaderInner: FC<EventInfoProps> = ({
	eventTitle,
	date,
	startTime,
	endTime,
	address,
	onSaleDate,
	hasPassword,
}: EventInfoProps) => {
	const zeroTime = onSaleDate === ZERO_TIME;

	return (
		// One stacked block: title first, then the supporting meta lines. The action buttons sit
		// beside this block, in the `right` slot of the dashboard's header PunchupSplitRow.
		<div className={styles.header}>
			<p className={styles.title}>
				{eventTitle}
				{hasPassword && <Lock size={20} className={styles.lockIcon} />}
			</p>
			<div className={styles.meta}>
				<p className={styles.metaText}>
					{date} · {startTime} – {endTime}
				</p>
				{!zeroTime && <p className={styles.metaText}>On sale: {onSaleDate}</p>}
				{address && (
					<div className={styles.addressRow}>
						<MapPin size={14} className={styles.addressIcon} aria-hidden="true" />
						<p className={styles.metaText}>{address}</p>
					</div>
				)}
			</div>
		</div>
	);
};

const memorizedEventInfo: FC<EventInfoProps> = memo(EventInfoHeaderInner);
export { memorizedEventInfo as EventInfoHeader };
